import React  from 'react';
import Classes from "classnames";

export default function renderBooleanGroupListHeader(id, props) {
    const { data, className } = props;

    const classes = Classes(className, 'gd-field-boolean-group-list-header');

    return (
        <div className={classes}>
            <div className="group-list-header-value">{data.value ? "Checked" : "Unchecked"}</div>
        </div>
    );
}